/* unplugin-vue-components disabled */import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "hero"
};
const _hoisted_2 = {
  class: "hero__contents"
};
const _hoisted_3 = {
  class: "hero__cta"
};
import { gsap, Linear } from "gsap";
import { track } from "@/analytics/events";
import { itiraStates } from "@/composable/vuelidate";
import { allClearItiraWithoutRedirect, emprtyAllCheckoutStatesVulidate } from "@/helpers/itira";
import { toRaw } from "vue";
import { random } from "gsap/gsap-core";
import { uuid } from 'vue-uuid';
import Bugsnag from "@bugsnag/js";
export default {
  __name: 'banner',
  setup(__props) {
    const {
      useState,
      useActions
    } = createNamespacedHelpers("itira");
    const plansStore = createNamespacedHelpers("plans");
    const headingRefHeadingTow = ref(null);
    const headingRefheadingOne = ref(null);
    const {
      resetItiraStore
    } = useActions(["resetItiraStore"]);
    const {
      itira
    } = useState(["itira"]);
    const {
      deleteAllCartItems
    } = plansStore.useActions(["deleteAllCartItems"]);
    const tl = gsap.timeline();

    // code for segment

    const trackPayload = {
      cart_id: itira.value?.itira_uuid ?? null
    };
    const userStore = createNamespacedHelpers("user");
    const {
      getCustomerInfo
    } = userStore.useGetters(["getCustomerInfo"]);
    const trackItiraPayload = {
      customer_info: toRaw(getCustomerInfo.value),
      cart_id: itira.value?.itira_uuid ?? null,
      event_id: uuid.v4(),
      event_name: "Itira Welcome"
    };
    const toIteraTravelReasons = () => {
      track("ITIRA - Start", {
        ...trackItiraPayload
      });
      Bugsnag.leaveBreadcrumb('Button clicked');
      track("Home Page Shop Plans", {
        ...trackPayload
      });
    };

    /*const resetItira = () => {
      let { itira_uuid } = toRaw(itira.value);
      deleteAllCartItems(itira_uuid);
      itiraStates.value = [];
      resetItiraStore();
      allClearItiraWithoutRedirect();
      emprtyAllCheckoutStatesVulidate();
    };
    resetItira();*/

    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        className: "hero__copy"
      }, [_createElementVNode("h1", {
        class: "hero__heading"
      }, [_createTextVNode(" Finally, travel insurance "), _createElementVNode("span", {
        class: "keep-together"
      }, "you can trust"), _createTextVNode(". ")]), _createElementVNode("h2", {
        class: "hero__subheading"
      }, "Get the best travel insurance using AI")], -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
        class: "btn-primary mobile__btn home-cta",
        to: "/itira/travel-reasons",
        onClick: toIteraTravelReasons
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("Check prices ")])),
        _: 1
      })])])]);
    };
  }
};